export default {
    title: 'Insira a nova senha',
    changePasswordButton: 'Recuperar senha',
    returnLogin: {
        button: 'Iniciar sessão',
    },
    success: {
        label: 'A senha foi atualizada com sucesso.'
    },
    password: {
        inputLabel: 'Senha',
        confirmInputLabel: 'confirmar senha'
    },
    badConfirmPassword: 'Senha não corresponde.',
    invalidToken: {
        title: 'Este link já foi usado',
        button: 'Ir para início da sessão',
        label: 'Problemas para acessar sua conta?'
    }
}

